module.exports = __webpack_public_path__ + "img/1.740a12ea.jpg";